function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import cls from "classnames";
import { useMemo, useRef, useState } from "react";
import { isUndefined } from "@firefly/fly-defter";
import { useIsomorphicLayoutEffect } from "../hook/useIsomorphicLayoutEffect";
import { useResizeEffect } from "../hook/useResizeEffect";
import { withStopPropagation } from "../util/dom/event";
import { mergeProps } from "../util/mergeProps";
import { createNamespace } from "../context/create";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var _createNamespace = createNamespace('typography'),
  _createNamespace2 = _slicedToArray(_createNamespace, 1),
  bem = _createNamespace2[0];
var Ellipsis = function Ellipsis(p) {
  var props = mergeProps(p, {
    rows: 1,
    expandText: '',
    collapseText: '',
    suffixText: '',
    symbol: '...',
    stopPropagationForActionButtons: []
  });
  var rootRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    ellipsised = _useState2[0],
    setEllipsised = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    exceeded = _useState6[0],
    setExceeded = _useState6[1];
  var suffixStr = useMemo(function () {
    if (props.suffixText) return props.suffixText;
    if (!isUndefined(props.suffixCount) && props.suffixCount > 0) {
      return props.children.slice(-props.suffixCount).trim();
    }
    return '';
  }, [props.suffixCount, props.suffixText]);
  function calcEllipsised() {
    var root = rootRef.current;
    if (!root) return;
    var originStyle = window.getComputedStyle(root);
    var container = document.createElement('div');
    var styleNames = Array.prototype.slice.apply(originStyle);
    styleNames.forEach(function (name) {
      container.style.setProperty(name, originStyle.getPropertyValue(name));
    });
    container.style.position = 'fixed';
    container.style.left = '999999px';
    container.style.top = '999999px';
    container.style.zIndex = '-1000';
    container.style.height = 'auto';
    container.style.minHeight = 'auto';
    container.style.maxHeight = 'auto';
    container.style.textOverflow = 'clip';
    container.style.whiteSpace = 'normal';
    container.style.webkitLineClamp = 'unset';
    container.style.display = 'block';
    var lineHeight = pxToNumber(originStyle.lineHeight);
    var maxHeight = Math.floor(lineHeight * (props.rows + 0.5) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom));
    container.innerHTML = props.children;
    document.body.appendChild(container);
    if (container.offsetHeight <= maxHeight) {
      setExceeded(false);
    } else {
      setExceeded(true);
      var end = props.children.length;
      var actionText = expanded ? props.collapseText : props.expandText;
      // eslint-disable-next-line no-inner-declarations
      function check(left, right) {
        if (right - left <= 1) {
          return {
            leading: props.children.slice(0, left) + props.symbol
          };
        }
        var middle = Math.round((left + right) / 2);
        container.innerHTML = props.children.slice(0, middle) + props.symbol + suffixStr + actionText;
        if (container.offsetHeight <= maxHeight) {
          return check(middle, right);
        }
        return check(left, middle);
      }
      var _ellipsised = check(0, end);
      setEllipsised(_ellipsised);
    }
    document.body.removeChild(container);
  }
  useResizeEffect(calcEllipsised, rootRef);
  useIsomorphicLayoutEffect(function () {
    calcEllipsised();
  }, [props.children, props.rows, suffixStr, props.expandText, props.collapseText]);
  var onExpandClick = function onExpandClick(isExpend) {
    var _props$onExpend;
    (_props$onExpend = props.onExpend) === null || _props$onExpend === void 0 || _props$onExpend.call(props, isExpend);
    setExpanded(isExpend);
  };
  var expandActionElement = exceeded && props.expandText ? withStopPropagation(props.stopPropagationForActionButtons, /*#__PURE__*/_jsx("a", {
    onClick: function onClick() {
      onExpandClick(true);
    },
    children: props.expandText
  })) : null;
  var collapseActionElement = exceeded && props.expandText ? withStopPropagation(props.stopPropagationForActionButtons, /*#__PURE__*/_jsx("a", {
    onClick: function onClick() {
      onExpandClick(false);
    },
    children: props.collapseText
  })) : null;
  var renderContent = function renderContent() {
    if (!exceeded) {
      return props.children;
    }
    if (expanded) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [props.children, collapseActionElement]
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [ellipsised.leading, suffixStr, expandActionElement]
      });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    ref: rootRef,
    className: cls(props.className, bem('ellipsis')),
    style: props.style,
    children: renderContent()
  });
};
function pxToNumber(value) {
  if (!value) return 0;
  var match = value.match(/^\d*(\.\d*)?/);
  return match ? Number(match[0]) : 0;
}
export default Ellipsis;